import { REACT_APP_BACKEND_API, REACT_APP_BACKEND_DIGITAL_SIGNATURE } from "../config";
import { handleServiceError } from "./errorHandler";
import { getHeadersApplication } from "./middleware";

const BASE_URL = REACT_APP_BACKEND_DIGITAL_SIGNATURE;


interface AdditionalField {
    field: string;
    name: string;
    label: string;
}

interface SignField {
    sign_field: string;
    date_field?: string;
    additional_fields: AdditionalField[];
}

interface SignatureContact {
    document_type: string;
    document_number: string;
    first_name: string;
    middle_name: string;
    last_name1: string;
    last_name2: string;
    country: string;
    email: string;
    phone: string;
    mobile: string;
    sign_method: string;
    sign_channel: string;
    sign_fields?: SignField;
}

interface FileMapping {
    search_name: string;
    target_file_name: string;
}

export interface SignatureRequest {
    ref_id: string;
    quote_id: string;
    entity_type: string;
    bucket: string;
    folder: string;
    subject: string;
    body: string;
    synchronous: boolean;
    frame_url?: string;
    client_url: string;
    back_url?: string;
    url_back?: string;
    locale: string;
    sender_email: string;
    contacts: SignatureContact[];
    language?:string;
    file_mappings?: FileMapping[];
    time2save_days?: number;
    time2close_days?: number;
    billing_cost: string;
}


export interface SamlRequest {
    ref_id: string;
}

export const requestFrameLogalty = async (
    request: SignatureRequest,
    provider: string,
): Promise<any> => {
    try {
        const response = await fetch(`${BASE_URL}v1/signature/bucket`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Application-Id': 'web',
                'provider': provider,
            },
            body: JSON.stringify(request),
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} `);
        }
        const data = await response;
        return data.json();
    } catch (error) {
        handleServiceError(error);
        throw error;
    }
};

export const getSamlLogalty = async (
    request: SamlRequest,
    provider: string,
): Promise<any> => {
    try {
        const response = await fetch(`${BASE_URL}v1/signature/pki/saml`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Application-Id': 'web',
                'provider': provider,
            },
            body: JSON.stringify(request),
        });

        if (!response.ok) {
            return null;
        }
        const data = await response;
        return data.json();
    } catch (error) {
        handleServiceError(error);
        return null;
    }
};
/**
 * El ref_id de la firma vigente. Tras un reenvío el intento tiene un external_id
 * propio (Logalty exige el externalId único), así que pedirle el SAML al quoteID
 * devolvería el sobre anterior — el del teléfono equivocado.
 */
export const getCurrentSignatureRef = async (quoteID: string): Promise<string> => {
    try {
        const response = await fetch(`${REACT_APP_BACKEND_API}application/${quoteID}/sign`, {
            method: 'GET',
            headers: getHeadersApplication(),
        });

        if (!response.ok) {
            return quoteID;
        }

        const body = await response.json();
        return body?.data?.external_id || body?.external_id || quoteID;
    } catch (error) {
        handleServiceError(error);
        return quoteID;
    }
};
